import PlanejamentoAcaoFluxo from './PlanejamentoAcaoFluxo.vue';

export default PlanejamentoAcaoFluxo;
